"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRatio = void 0;
const isValidNumber = (value) => value !== null && value !== undefined && !Number.isNaN(value);
const getRatio = (numerator, denominator, options) => {
    if (!isValidNumber(numerator) || !isValidNumber(denominator) || denominator === 0) {
        return options?.fallback ?? null;
    }
    return numerator / denominator;
};
exports.getRatio = getRatio;
//# sourceMappingURL=get-ratio.js.map